//
//
//
//
//
//
//
//

import color from "@/mixins/color";
export default {
  name: "topColor",
  mixins: [color()],
  data: function data() {
    return {
      chalk: "",
      predefine: ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399', '#C71539']
    };
  }
};